import { SVGProps } from "react";

const ImageFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.22086 35C5.62086 39 8.05419 39.6667 9.22086 39.5H31.7188C34.5187 39.5 35.2188 36.5 35.2188 35V12V11.5L24.2188 0.5H8.71875C5.91875 0.5 5.22016 3.83333 5.22086 5.5C5.05419 13.6667 4.82086 31 5.22086 35Z"
      fill="#2589FF"
    />
    <path d="M24.2188 11.5H35.2188L24.2188 0.5V11.5Z" fill="#56A7FF" />
    <path
      d="M15.9167 21.625H24.0833C24.4515 21.625 24.75 21.9235 24.75 22.2917V30.4583C24.75 30.8265 24.4515 31.125 24.0833 31.125H15.9167C15.5485 31.125 15.25 30.8265 15.25 30.4583V22.2917C15.25 21.9235 15.5485 21.625 15.9167 21.625Z"
      fill="white"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5262 28.1841L22.3851 25.519C21.9986 24.6148 21.2877 24.5783 20.8101 25.4387L20.121 26.682C19.771 27.3127 19.1184 27.3674 18.6663 26.8023L18.5861 26.7002C18.1158 26.1096 17.4522 26.1825 17.1132 26.857L16.4861 28.1148C16.0449 28.9898 16.683 30.0216 17.6601 30.0216H22.3121C23.2601 30.0216 23.8981 29.0554 23.5262 28.1841Z"
      fill="#007AF5"
    />
    <path
      d="M18.1641 24.918C18.7681 24.918 19.2578 24.4283 19.2578 23.8242C19.2578 23.2202 18.7681 22.7305 18.1641 22.7305C17.56 22.7305 17.0703 23.2202 17.0703 23.8242C17.0703 24.4283 17.56 24.918 18.1641 24.918Z"
      fill="#007AF5"
    />
  </svg>
);
export default ImageFile;
